var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vacuo"},[_c('img',{staticClass:"vacuoImg",attrs:{"src":require("@/assets/image/activity/cite/poster.jpg")}}),_c('div',{staticClass:"footerMod",on:{"click":_vm.getAttendMeetings}},[_c('p',[_vm._v("我要参会")])])])}
var staticRenderFns = []

export { render, staticRenderFns }